<template>
	<NuxtLink :to="inject('baseDir') + article?.slug">
		<span>{{ article.title }}</span>
	</NuxtLink>
</template>

<script setup lang="ts">
defineProps<{ 
	article: any;
}>()
</script>
